/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misty_Livid_Turtle_LinkInputs */

const en_misty_livid_turtle_link = /** @type {(inputs: Misty_Livid_Turtle_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie settings`)
};

const de_misty_livid_turtle_link = /** @type {(inputs: Misty_Livid_Turtle_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie-Einstellungen`)
};

/**
* | output |
* | --- |
* | "Cookie settings" |
*
* @param {Misty_Livid_Turtle_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const misty_livid_turtle_link = /** @type {((inputs?: Misty_Livid_Turtle_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misty_Livid_Turtle_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_misty_livid_turtle_link(inputs)
	return de_misty_livid_turtle_link(inputs)
});